class MapProvider {
  constructor() {
    this.maps = {};
  }
  set(map, name = 'map') {
    this.maps[name] = map;
  }
  get(name = 'map') {
    return this.maps[name];
  }
  isMapAvailable(name = 'map') {
    return this.get(name) != null;
  }
  setPointer(pointer, name = 'map') {
    const map = this.get(name);
    if (map) {
      map.setPointer(pointer);
      return true;
    }
    return false;
  }
  getCenter(name = 'map') {
    const mapViewer = this.get(name);
    if (mapViewer) {
      const cnt = mapViewer.map?.getCenter();
      return cnt ? {
        lat: typeof cnt.lat === 'function' ? cnt.lat() : cnt.lat,
        lon: typeof cnt.lng === 'function' ? cnt.lng() : cnt.lng
      } : null;
    }
    return null;
  }
}
const singleton = new MapProvider();
export default singleton;